// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropzone[data-v-5c21f030] {\n\toutline: 2px dashed #92b0b3;\n\toutline-offset: -10px;\n\t-webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;\n\ttransition: outline-offset .15s ease-in-out, background-color .15s linear;\n}\n.dropzone.dragover[data-v-5c21f030] {\n\t\toutline-offset: -20px;\n\t\toutline-color: #c8dadf;\n\t\tbackground-color: #fff0f0; /* Light pink */\n}\n", ""]);
// Exports
module.exports = exports;
